export default "__VITE_ASSET__BcNg_QQk__"